import React from 'react';
import { Typography } from 'antd';
import { PUSH_FONT } from '@/utils/matchPushCopy';

const { Text } = Typography;

interface Props {
  /** Small caption above the phone, e.g. 'English · version A'. */
  caption?: string;
  title: string;
  body: string;
  /** The fixed note under the notification, e.g. 'custom copy for this match'. */
  note?: string;
}

/** A notification as it looks on a phone; text uses the Devanagari font fallback. */
export const PhoneNotification: React.FC<Props> = ({ caption, title, body, note }) => (
  <div
    style={{
      border: '1px solid var(--ant-color-border, #d9d9d9)',
      borderRadius: 18,
      padding: 12,
      marginBottom: 12,
    }}
  >
    {caption && (
      <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 6 }}>
        {caption}
      </Text>
    )}
    <div
      style={{
        background: 'var(--ant-color-fill-quaternary, rgba(0,0,0,0.04))',
        borderRadius: 12,
        padding: '10px 12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        fontSize: 13,
        fontFamily: PUSH_FONT,
      }}
    >
      <div style={{ fontSize: 11, opacity: 0.65, marginBottom: 3 }}>WCC4 · now</div>
      <div style={{ fontWeight: 600, marginBottom: 2 }}>{title}</div>
      <div>{body}</div>
    </div>
    {note && (
      <Text type="secondary" style={{ display: 'block', fontSize: 11, marginTop: 6 }}>
        {note}
      </Text>
    )}
  </div>
);
